export const DEBOUNCE_TIMER = 0.5 * 1000 //in milliseconds
export const REDIRECT_TIMER = 2 * 1000 * 1 //in milliseconds

export const DROPDOWN_DEFAULT_VALUE = -1

export const FORMATS = {
  DATE: 'DD MMM YYYY',
  DATETIME: 'DD MMM YYYY, hh:mm A',
}

export const FIELD_TYPES = {
  BIGTEXT: 'bigtext',
  DATE: 'date',
  DATETIME: 'datetime',
  TEXT: 'text',
  LIST: 'list',
  LIST_MULTI: 'list-multi',
  TABLE: 'table',
  FILE: 'file',
  CURRENCY: 'currency',
  NUMBER: 'number',
  CUSTOM_VIEW: 'custom-view',
  TIMESTAMPED_BIGTEXT: 'timestamped-bigtext',
}

export const STYLES = {
  COMMON: {
    field: { marginTop: 8, marginBottom: 8, display: 'block' },
    error: { marginTop: 10, marginBottom: 20, display: 'block', color: 'red' },
  },
}

export const CATEGORY_CONTEXT = {
  MY_TASKS: 'my-tasks',
  MY_PROCESSES: 'my-processes',
}

export const TABLE_FIELD_CONSTRAINTS = {
  UNIQUE: 'unique',
  MIN_1_MATCH: 'min-1-match',
}

export const FIELD_CONSTRAINTS = {
  POSITIVE: 'positive',
  WHOLE_NUM: 'whole-num',
  INT: 'int',
  POSITIVE_INT: 'positive-int',
  LTE: 'lte',
  LT: 'lt',
  GTE: 'gte',
  GT: 'gt',
  EQUAL: 'eq',
  EQ: 'equal',
}

export const FIELD_CONSTRAINTS_MESSAGE = {
  lte: 'less than or equal to',
  lt: 'less than',
  gte: 'greater than or equal to',
  gt: 'greater than',
  eq: 'equal to',
}

export const VIEW_OR_INITIATE_PROCESS = { VIEW: 'view', INITIATE: 'initiate' }

export const COMPUTED_OPERATION_TYPES = {
  CONCAT: 'concat',
  MULTIPLY: 'multiply',
  SUM: 'sum',
  CONCAT_TABLE_COLUMN: 'concat-table-column',
  MULTIPLY_TABLE_COLUMN: 'multiply-table-column',
  SUM_TABLE_COLUMN: 'sum-table-column',
  SUM_ACROSS_PROCESS: 'sum-across-process',
  RANDOM_UID: 'random-uid',
  SERIAL: 'serial-uid',
}

export const COMPUTED_RESERVED_KEYS = {
  LIST_DATA_ID: 'id',
  CODE: 'code',
  VALUE: 'value',
  PROCESS_PREFIX: 'process_prefix',
  PROCESS_REFERENCE_NUM: 'process_reference_num',
  CURRENT_FINANCIAL_YEAR: 'current_financial_year',
  COUNTER: 'counter',
  PROCESS_COUNTER: 'process_counter',
  SL_NO: 'sl_no',
  VERSION: 'version',
}

export const ACTIVITY_TYPES = {
  DATA_ENTRY: 'data-entry',
  REVIEW: 'review',
  END_ACCEPTED: 'end-accepted',
  END_REJECTED: 'end-rejected',
  COMMITTEE_DATA_ENTRY: 'committee-data-entry',
  COMMITTEE_REVIEW: 'committee-review',
  LONG_RUNNING: 'long-running',
  PARALLEL_START: 'parallel_start',
  PARALLEL_END: 'parallel_end',
}

export const ROUTE_TYPES = {
  PROGRESS: 'progress',
  REGRESS: 'regress',
  NEUTRAL: 'neutral',
}

export const PROCESS_ACTIVITY_STATUSES = {
  CLOSED: 'closed',
  ACTIVE: 'active',
  DELEGATED: 'delegated',
}

export const PROCESS_VERSION = {
  VERSION: 1,
}

export const PROCESS_STATUSES = {
  CLOSED_ACCEPTED: 'Closed (Accepted)',
  CLOSED_REJECTED: 'Closed (Rejected)',
  ACTIVE: 'Active',
}

export const REVIEW_CONTEXTS = {
  FIRST_DATA_ENTRY: 'first-data-entry',
  SUBSEQUENT_DATA_ENTRY: 'subsequent-data-entry',
  REVIEW: 'review',
  LONG_RUNNING: 'long-running',
}

export const TOAST_SETTINGS = {
  position: 'top-right',
  autoClose: 2000,
  closeOnClick: true,
  hideProgressBar: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export const TOAST_SETTINGS_ERROR = {
  position: 'top-right',
  autoClose: 10000,
  closeOnClick: true,
  hideProgressBar: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export const PREVIEW_SUBFIELD_COLUMN_WIDTH_PERCENTAGE = 0.8

export const FIELD_OPERATORS = { EQUAL: 'equal', UNEQUAL: 'unequal' }

export const TABLE_CONTEXTS = {
  DATA_ENTRY_VIEW: 'data-entry-view',
  DATA_PREVIEW_VIEW: 'data-preview-view',
}

export const TABLE_CONFIG_CONTEXTS = {
  HIDDEN_COLUMN: 'hidden-column',
  GROUP_DATA: 'group-data',
  VERTICAL_FREEZE: 'vertical-freeze',
}

export const DYNAMIC_FIELD_TYPE = {
  TEAMS: 'teams',
  USERS: 'users',
}

export const TEAM_TYPES = {
  INTERNAL: 'internal',
  CONTRACTOR: 'contractor',
  CONSULTANT: 'consultant',
}

export const TEAM_SUB_TYPES = {
  SUB_FUNCTION: 'sub-function',
}

export const GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
}

export const BLOOD_GROUPS = {
  A_POSITIVE: 'A+',
  A_NEGATIVE: 'A-',
  B_POSITIVE: 'B+',
  B_NEGATIVE: 'B-',
  AB_POSITIVE: 'AB+',
  AB_NEGATIVE: 'AB-',
  O_POSITIVE: 'O+',
  O_NEGATIVE: 'O-',
}

export const EMPLOYMENT_TYPES = {
  FULL_TIME: 'full-time',
  PART_TIME: 'part-time',
  CONTRACT: 'contract',
  TEMPORARY: 'temporary',
  INTERN: 'intern',
  FREELANCE: 'freelance',
  CONSULTANT: 'consultant',
  SEASONAL: 'seasonal',
  APPRENTICE: 'apprentice',
  PER_DIEM: 'per diem',
}

export const PROTECTED_LIST_TYPES = {
  PROCESS_REFERENCE: 'process-reference',
}

export const RECURRING_TABLE_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  BIANNUAL: 'biannual',
  ANNUAL: 'annual',
}

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
}

export const VALUE_OPERATION = {
  plus: '+',
  minus: '-',
  none: null,
}

export const OUTBOUND_TRANSLATION_TABLE_OPERATION = {
  REPLACE_TABLE_DATA: 'replace-table-data', // replace complete table data
  ADD_TABLE_ROW: 'add-table-row',
  REPLACE_TABLE_ROW: 'replace-table-row', // matching_keys are required
  DELETE_TABLE_ROW: 'delete-table-row', // matching_keys are required
}

export const OUTBOUND_SERVER_ACTION_LIST_DATA_TYPE = {
  ID: 'id',
  VALUE: 'value',
  METADATA: 'metadata',
}

export const OUTBOUND_SERVER_ACTION_LIST_DATA_METADATA_KEY = {
  PROCESS_REFERENCE_KEY: 'process_reference_num',
  PROCESS_TEMPLATE_ID: 'process_template_id',
  EMAIL: 'email',
}

export const LOGIC_GATE = {
  AND: 'AND',
  OR: 'OR',
  NOR: 'NOR',
}

export const WEEKDAYS = {
  SUN: 0,
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
}

export const MONTHS = {
  JAN: 1,
  FEB: 2,
  MAR: 3,
  APR: 4,
  MAY: 5,
  JUN: 6,
  JUL: 7,
  AUG: 8,
  SEP: 9,
  OCT: 10,
  NOV: 11,
  DEC: 12,
}

export const DATES = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
  28, 29, 30, 31,
]

export const HOURS = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
]

export const EXCEL_COLUMNS_COLOR = ['ebebe0', 'd7d7c1', 'b9b992']

export const timelineColorCode = {
  'data-entry': '#4CAF50 ',
  review: '#F09536 ',
  'parallel-data-entry': '#80C7A3 ',
  'parallel-review': '#FFB74D ',
  'long-running': '#7E57C2 ',
  delegation: '#4CAF50 ',
  'end-rejected': '#cb4c4a',
  'end-accepted': '#4CAF50',
}

export const EXCEL_COLUMNS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'AA',
  'AB',
  'AC',
  'AD',
  'AE',
  'AF',
  'AG',
  'AH',
  'AI',
  'AJ',
  'AK',
  'AL',
  'AM',
  'AN',
  'AO',
  'AP',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AV',
  'AW',
  'AX',
  'AY',
  'AZ',
  'BA',
  'BB',
  'BC',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BK',
  'BL',
  'BM',
  'BN',
  'BO',
  'BP',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BU',
  'BV',
  'BW',
  'BX',
  'BY',
  'BZ',
  'CA',
  'CB',
  'CC',
  'CD',
  'CE',
  'CF',
  'CG',
  'CH',
  'CI',
  'CJ',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CP',
  'CQ',
  'CR',
  'CS',
  'CT',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DA',
  'DB',
  'DC',
  'DD',
  'DE',
  'DF',
  'DG',
  'DH',
  'DI',
  'DJ',
  'DK',
  'DL',
  'DM',
  'DN',
  'DO',
  'DP',
  'DQ',
  'DR',
  'DS',
  'DT',
  'DU',
  'DV',
  'DW',
  'DX',
  'DY',
  'DZ',
  'EA',
  'EB',
  'EC',
  'ED',
  'EE',
  'EF',
  'EG',
  'EH',
  'EI',
  'EJ',
  'EK',
  'EL',
  'EM',
  'EN',
  'EO',
  'EP',
  'EQ',
  'ER',
  'ES',
  'ET',
  'EU',
  'EV',
  'EW',
  'EX',
  'EY',
  'EZ',
  'FA',
  'FB',
  'FC',
  'FD',
  'FE',
  'FF',
  'FG',
  'FH',
  'FI',
  'FJ',
  'FK',
  'FL',
  'FM',
  'FN',
  'FO',
  'FP',
  'FQ',
  'FR',
  'FS',
  'FT',
  'FU',
  'FV',
  'FW',
  'FX',
  'FY',
  'FZ',
  'GA',
  'GB',
  'GC',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GJ',
  'GK',
  'GL',
  'GM',
  'GN',
  'GO',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GV',
  'GW',
  'GX',
  'GY',
  'GZ',
]

export const CURRENCY_COUNTRY_CODE = {
  USD: '$',
  EUR: '€',
  JPY: '¥',
  GBP: '£',
  AUD: 'A$',
  CAD: 'C$',
  CHF: 'CHF',
  CNY: '¥',
  SEK: 'kr',
  INR: '₹',
  ERR: '?',
}

export const TABLE_ADD_ROW_TYPE = {
  ADD_ROW: 'add-row',
  COPY_ROW: 'copy-row',
}

export const MANAGER_LEVEL_BAND = [
  'E3',
  'M1',
  'M2',
  'M3',
  'M4',
  'M5',
  'M6',
  'S1',
  ' S2',
  'S3',
  'L1',
]

export const STANDARD_COLORS = {
  PREVIEW_REJECTED: '#e31717',
  PREVIEW_ACCEPTED: '#065406',
  REVIEW_SWITCH_TINT_ACCEPT: '#51AD46',
  REVIEW_SWITCH_TINT_REJECT: '#DE3A3B',
  REVIEW_SWITCH_TINT_NEUTRAL: '#c6c3c3',

  // Text
  TEXT_DEFAULT: '#27104e',
  TEXT_ACCEPTED: '#065406',
  TEXT_REJECTED: '#e31717',

  // Backgrounds
  BG_EDITABLE: '#ffffff',
  BG_READONLY: '#f5f7ff',
}
